package top.wcpe.allincore.dsl.compiler.semantic

/**
 * DSL 中的事件 prop 名集合。
 *
 * 凡是名字落在该集合中的 prop，其右值必须是 [top.wcpe.allincore.dsl.compiler.ast.ExprAst.CallExpr]
 * 或 [top.wcpe.allincore.dsl.compiler.ast.ExprAst.FunRefExpr]
 * （即无参 fun 调用或 ::fun 引用），否则在语义阶段报 DSL_E301。
 */
internal object EventProps {
    /**
     * DSL 中所有"事件 prop"名称集合：右值必须是无参 fun 入口。
     *
     * 包含两类：
     * - 观察事件：onClick / onChange / onRightClick / onLongPress / onDoubleClick / onDragEnter / onDragLeave / onHover
     * - 拦截器（interceptor）：interceptClick / interceptRightClick / interceptDrop
     *   拦截器走与观察事件相同的 binding 形式，但运行时会取其返回值，若返回 true 则阻止默认行为；
     *   当前 Stage 仅完成白名单与 binding 接线，实际拦截链调用在 Stage E7 (InputDispatcher) 实现。
     */
    val NAMES: Set<String> = setOf(
        "onClick", "onChange",
        // textfield 回车提交回调
        "onSubmit",
        "onRightClick", "onLongPress", "onDoubleClick",
        "onDragEnter", "onDragLeave", "onHover",
        "interceptClick", "interceptRightClick", "interceptDrop",
        // M6-h Round 1：modal 关闭事件回调
        "onDismiss",
        // Phase 3 C 类装饰器回调：下拉刷新 / 上拉加载 / 拖拽重排
        "onRefresh", "onLoadMore", "onReorder",
        // Phase 4 全局拖拽回调：开始拖拽 / 拖拽悬停 / 放下
        "onDragStart", "onDragOver", "onDrop",
        // v4 C.2：通用拖拽 / 指针移动 / 滚轮事件 prop（onWheel 是 onScroll 的 DSL 别名）
        "onDrag", "onDragEnd",
        "onPointerMove",
        "onWheel",
    )
}
